import { ArrowLeft } from 'lucide-react';
import { Link, Outlet } from '@tanstack/react-router';

import { AtlasIcon } from '@crossnokaye/ux-animatics';
import { Separator } from '@crossnokaye/ux-common';

import { AppConfigs } from '@/config';

export function AtlasLayout(): React.ReactElement {
  return (
    <div id={'layout-container'} className={'flex flex-row flex-1 min-h-0 bg-background isolate'}>
      <div
        id={'content-container'}
        className={'flex flex-col flex-1 overflow-hidden overflow-y-auto min-h-0'}
      >
        <div className={'mx-auto w-full max-w-5xl pt-6 sticky top-0 z-10 bg-background'}>
          <AtlasIcon symbol={'atlasLogoFull'} width={'10rem'} height={'1.5rem'} />
          <Separator className={'mb-2 mt-6'} />
          <Link
            to={AppConfigs.atlasEnvUrl.toString()}
            className={
              'mx-8 flex items-center gap-2 justify-start bg-transparent text-foreground font-medium'
            }
          >
            <ArrowLeft className={'w-4 h-4'} />
            {'Back to Control System'}
          </Link>
          <Separator className={'mt-2'} />
        </div>

        <Outlet />
      </div>
    </div>
  );
}
